import { DatePicker } from "antd";
import { ChevronUp, Info } from "feather-icons-react/build/IconComponents";
import ArrowLeft from "feather-icons-react/build/IconComponents/ArrowLeft";
import React, { useEffect, useState } from "react";
import { PlusCircle } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import { createEmployee } from "../../service/ApiServices";
import dayjs from "dayjs";

const AddEmployee = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate();

  // fetch shift details and set it to options
  const [shiftOptions, setShiftOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/shifts")
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const processedShiftOptions = data.data.shifts.map(item => ({
          value: item._id,
          label: item.shiftInfo.shiftName
        }));
        setShiftOptions(processedShiftOptions);
      })
      .catch(error => console.error('Error fetching shifts:', error));
  }, []);

  // fetch designation details and set it to options
  const [designationOptions, setDesignationOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/designations")
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        const processedDesignationOptions = data.data.designations.map(item => ({
          value: item._id,
          label: item.designationName
        }));
        setDesignationOptions(processedDesignationOptions);
      })
      .catch(error => console.error('Error fetching designations:', error));
  }, []);

  // fetch department details and set it to options
  const [departmentOptions, setDepartmentOptions] = useState([]);

  useEffect(() => {
    fetch("http://localhost:8000/api/departments")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const processedDepartmentOptions = data.data.departments.map(item => ({
          value: item._id,
          label: item.departmentName
        }));
        setDepartmentOptions(processedDepartmentOptions);
      })
      .catch(error => console.error('Error fetching department:', error));
  }, []);

  // fetch country name and set it to country option
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch('https://restcountries.com/v3.1/all');
        const data = await response.json();
        // console.log(data);
        const processedCountryOptions = data.map(country => ({
          value: country.name.common,
          label: country.name.common
        }));
        setCountries(processedCountryOptions);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

  // fetch nationalities and set to country option
  const [nationalitiesOptions, setNationality] = useState([]);

  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const response = await fetch('https://restcountries.com/v3.1/all');
        const data = await response.json();
        const nationalities = data.reduce((acc, country) => {
          if (country.demonyms && country.demonyms.eng) {
            acc.push(country.demonyms.eng.m);
            acc.push(country.demonyms.eng.f);
          }
          return acc;
        }, []);
        const uniqueNationalities = [...new Set(nationalities)];
        const processedNationalityOptions = uniqueNationalities.map(nationality => ({
          value: nationality,
          label: nationality
        }));
        setNationality(processedNationalityOptions);
      } catch (error) {
        console.error('Error fetching nationalities:', error);
      }
    };

    fetchNationalities();
  }, []);


  const [formData, setFormData] = useState({
    fullName: '',
    title: '',
    email: '',
    contactNumber: '',
    epfNumber: '',
    nic: '',
    dateOfBirth: null,
    gender: '',
    nationality: '',
    joiningDate: null,
    shiftId: '',
    departmentId: '',
    designationId: '',
    bloodGroup: '',
    emergencyNo1: '',
    emergencyNo2: '',
    address: '',
    country: '',
    state: '',
    city: '',
    zipcode: '',
    bankName: '',
    bankCode: '',
    bankBranch: '',
    bankBranchCode: '',
    accountHolderName: '',
    accountNumber: '',
  });

  const [confirmPassword, setConfPassword] = useState('');
  const [fileList, setFileList] = useState([]);
  const [uploadedPic, setUploadedPic] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileList([file]); // Store native file in an array to minimize submit logic changes
      const previewUrl = URL.createObjectURL(file);
      setUploadedPic(previewUrl);
    } else {
      setFileList([]);
      setUploadedPic("");
    }
  };

  const handlePasswordChange = (event) => {
    setFormData({ ...formData, password: event.target.value });
  };

  const handleConfirmPasswordChange = (event) => {
    setConfPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.gender || formData.gender === "" || formData.gender === "Choose") {
      toast.error("Gender is required");
      return;
    }

    const formDataToSend = new FormData();
    const appendIfValue = (key, value) => {
      if (value !== undefined && value !== null && value !== '') {
        formDataToSend.append(key, value);
      }
    };

    const dobValue = formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString() : '';
    const joinValue = formData.joiningDate ? new Date(formData.joiningDate).toISOString() : '';

    appendIfValue('full_name', formData.fullName);
    appendIfValue('title', formData.title);
    appendIfValue('email', formData.email);
    appendIfValue('contactNumber', formData.contactNumber);
    appendIfValue('contact_number', formData.contactNumber);
    appendIfValue('epfNumber', formData.epfNumber);
    appendIfValue('epf_number', formData.epfNumber);
    appendIfValue('nic', formData.nic);
    appendIfValue('dateOfBirth', dobValue);
    appendIfValue('date_of_birth', dobValue);
    appendIfValue('gender', formData.gender);
    appendIfValue('nationality', formData.nationality);
    appendIfValue('joiningDate', joinValue);
    appendIfValue('joining_date', joinValue);
    appendIfValue('shift', formData.shiftId);
    appendIfValue('departmentId', formData.departmentId);
    appendIfValue('department_id', formData.departmentId);
    appendIfValue('designationId', formData.designationId);
    appendIfValue('designation_id', formData.designationId);
    appendIfValue('bloodGroup', formData.bloodGroup);
    appendIfValue('blood_group', formData.bloodGroup);
    appendIfValue('emergencyNo1', formData.emergencyNo1);
    appendIfValue('emergency_no_1', formData.emergencyNo1);
    appendIfValue('emergencyNo2', formData.emergencyNo2);
    appendIfValue('emergency_no_2', formData.emergencyNo2);
    appendIfValue('address', formData.address);
    appendIfValue('city', formData.city);
    appendIfValue('province', formData.state);
    appendIfValue('country', formData.country);
    appendIfValue('zipcode', formData.zipcode);
    appendIfValue('bankName', formData.bankName);
    appendIfValue('bank', formData.bankName);
    appendIfValue('bank_code', formData.bankCode);
    appendIfValue('bank_branch', formData.bankBranch);
    appendIfValue('bank_branch_code', formData.bankBranchCode);
    appendIfValue('branch_code', formData.bankBranchCode);
    appendIfValue('accountHolderName', formData.accountHolderName);
    appendIfValue('account_holder', formData.accountHolderName);
    appendIfValue('accountNumber', formData.accountNumber);
    appendIfValue('account_number', formData.accountNumber);

    if (fileList.length > 0) {
      formDataToSend.append("profilePicture", fileList[0]);
    }

    try {
      const response = await createEmployee(formDataToSend);
      if (response) {
        toast.success("Employee created successfully");
        navigate(route.employeegrid);
      }
      setFormData({
        fullName: '',
        title: '',
        email: '',
        contactNumber: '',
        epfNumber: '',
        nic: '',
        dateOfBirth: null,
        gender: '',
        nationality: '',
        joiningDate: null,
        shiftId: '',
        departmentId: '',
        designationId: '',
        bloodGroup: '',
        emergencyNo1: '',
        emergencyNo2: '',
        address: '',
        country: '',
        state: '',
        city: '',
        zipcode: '',
        bankName: '',
        bankCode: '',
        bankBranch: '',
        bankBranchCode: '',
        accountHolderName: '',
        accountNumber: '',
      });
      setFileList([]);
      setUploadedPic("");
    } catch (error) {
      console.error('Error creating employee:', error);
      toast.error(error.message || "Failed to create employee");
    }

  };


  const handleChange = (event, fieldOverride) => {
    const { name, value, type } = event.target;
    const key = fieldOverride || name;
    let newValue = value;

    if (type === 'file') {
      newValue = event.target.files[0];
    } else if (type === 'date') {
      const selectedDate = new Date(value);
      newValue = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
    } else if (key === 'fullName' || key === 'city' || key === 'state' || key === 'bankName' || key === 'bankBranch' || key === 'accountHolderName') {
      // Only letters, spaces, hyphens, and apostrophes
      if (value === '' || /^[a-zA-Z\s'-]+$/.test(value)) {
        newValue = value;
      } else {
        return; // Reject invalid input
      }
    } else if (key === 'contactNumber' || key === 'emergencyNo1' || key === 'emergencyNo2' || key === 'accountNumber' || key === 'bankCode' || key === 'bankBranchCode') {
      // Only digits, max 10
      if (value === '' || /^\d{0,10}$/.test(value)) {
        newValue = value;
      } else {
        return;
      }
    } else if (key === 'zipcode') {
      // Only digits
      if (value === '' || /^\d+$/.test(value)) {
        newValue = value;
      } else {
        return;
      }
    } else if (key === 'nic') {
      // Allow digits, V, X (case insensitive), and spaces
      if (value === '' || /^[0-9VXvx\s]+$/.test(value)) {
        newValue = value.replace(/\s+/g, '').toUpperCase(); // Auto-trim spaces and uppercase
      } else {
        return; // Reject invalid input
      }
    }

    setFormData({
      ...formData,
      [key]: newValue,
    });
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const handleToggleConfirmPassword = () => {
    setConfirmPassword((prevShowPassword) => !prevShowPassword);
  };
  const gender = [
    { value: "Choose", label: "Choose" },
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];
  const nationality = [
    { value: "Choose", label: "Choose" },
    // { value: "United Kingdom", label: "United Kingdom" },
    // { value: "India", label: "India" },
    ...nationalitiesOptions
  ];
  const shifts = [
    { value: "Choose", label: "Choose" },
    // { value: "Regular", label: "Regular" },
    ...shiftOptions
  ];
  const departments = [
    { value: "Choose", label: "Choose" },
    // { value: "UI/UX", label: "UI/UX" },
    // { value: "Support", label: "Support" },
    // { value: "HR", label: "HR" },
    // { value: "Engineering", label: "Engineering" },
    ...departmentOptions
  ];
  const designation = [
    { value: "Choose", label: "Choose" },
    // { value: "Designer", label: "Designer" },
    // { value: "Developer", label: "Developer" },
    // { value: "Tester", label: "Tester" },
    ...designationOptions
  ];
  const bloodgroup = [
    // { value: "Select", label: "Select" },
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B-" },
    { value: "O+", label: "O-" },
    { value: "O+", label: "O-" },
    { value: "AB+", label: "AB-" },
    { value: "AB+", label: "AB-" },
  ];
  const country = [
    { value: "Choose", label: "Choose" },
    // { value: "United Kingdom", label: "United Kingdom" },
    // { value: "USA", label: "USA" },
    ...countries
  ];

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value,
    });
  };

  return (
    <div>
      <div className="page-wrapper">
        <ToastContainer />
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>New Employee</h4>
                <h6>Create new Employee</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="page-btn">
                  <Link to={route.employeegrid} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Employee List
                  </Link>
                </div>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body">
                <div className="new-employee-field">
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Employee Informations
                    </h6>
                  </div>
                  <div className="profile-pic-upload">
                    <div className="profile-pic">
                      <span>
                        {uploadedPic ? (
                          <img
                            src={uploadedPic}
                            alt="Profile Preview"
                            style={{
                              width: '100%',
                              height: '100%',
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          <>
                            <PlusCircle className="plus-down-add" />
                            Profile Photo
                          </>
                        )}
                      </span>
                    </div>
                    <div className="input-blocks mb-0">
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={handleFileChange}
                        style={{ marginTop: '10px' }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-2">
                      <div className="mb-3">
                        <label className="form-label">Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={formData.title}
                          onChange={(event) => handleChange(event, 'title')}
                          placeholder="Enter Title"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                      <div className="mb-3">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          placeholder="Enter Full Name"
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter Email"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Contact Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactNumber"
                          value={formData.contactNumber}
                          onChange={handleChange}
                          placeholder="Enter Contact Number"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Emp Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="epfNumber"
                          value={formData.epfNumber}
                          onChange={handleChange}
                          placeholder="Enter Emp Code"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">NIC</label>
                        <input
                          type="text"
                          className="form-control"
                          name="nic"
                          value={formData.nic}
                          onChange={handleChange}
                          placeholder="Enter NIC"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-blocks">
                        <label>Date of Birth</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={formData.dateOfBirth ? dayjs(formData.dateOfBirth) : null}
                            onChange={(date) => setFormData({ ...formData, dateOfBirth: date ? date.toDate() : null })}
                            className="filterdatepicker"
                            format="DD-MM-YYYY"
                            placeholder="Select Date of Birth"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Gender *</label>

                        <Select
                          name="gender"
                          value={gender.find(option => option.value.toLowerCase() === formData.gender?.toLowerCase())}
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'gender')}
                          className="select"
                          options={gender}
                          placeholder="Select Gender"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Nationality</label>

                        <Select
                          name="nationality"
                          value={nationality.find(option => option.value === formData.nationality)}
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'nationality')}
                          className="select"
                          options={nationality}
                          placeholder="Select Nationality"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-blocks">
                        <label>Joining Date</label>
                        <div className="input-groupicon calender-input">
                          <DatePicker
                            value={formData.joiningDate ? dayjs(formData.joiningDate) : null}
                            onChange={(date) => setFormData({ ...formData, joiningDate: date ? date.toDate() : null })}
                            className="filterdatepicker"
                            format="DD-MM-YYYY"
                            placeholder="Select Joining Date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <div className="add-newplus">
                          <label className="form-label">Shift</label>
                          <Link to="#">
                            <span>
                              <PlusCircle className="plus-down-add" />
                              Add new
                            </span>
                          </Link>
                        </div>

                        <Select
                          className="select"
                          value={shifts.find(option => option.value === formData.shiftId) || null}
                          options={shifts}
                          placeholder="Select Shift"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'shiftId')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Department</label>

                        <Select
                          className="select"
                          value={departments.find(option => option.value === formData.departmentId) || null}
                          options={departments}
                          placeholder="Select Department"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'departmentId')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Designation</label>

                        <Select
                          className="select"
                          value={designation.find(option => option.value === formData.designationId) || null}
                          options={designation}
                          placeholder="Select Designation"
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'designationId')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Blood Group</label>
                        <Select
                          name="bloodGroup"
                          value={bloodgroup.find(option => option.value === formData.bloodGroup)}
                          onChange={(selectedOption) => handleSelectChange(selectedOption, 'bloodGroup')}
                          className="select"
                          options={bloodgroup}
                          placeholder="Select Blood Group"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="other-info">
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <Info className="feather-edit" />
                        </span>
                        Other Information
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Emergency No 1</label>
                          <input
                            type="text"
                            className="form-control"
                            name="emergencyNo1"
                            value={formData.emergencyNo1}
                            onChange={handleChange}
                            placeholder="Enter Emergency No 1"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Emergency No 2</label>
                          <input
                            type="text"
                            className="form-control"
                            name="emergencyNo2"
                            value={formData.emergencyNo2}
                            onChange={handleChange}
                            placeholder="Enter Emergency No 2"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6"></div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Address</label>
                          <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Enter Address"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Country</label>

                          <Select
                            name="country"
                            value={country.find(option => option.value === formData.country) || null}
                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'country')}
                            className="select"
                            options={country}
                            placeholder="Select Country"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">State</label>
                          <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                            placeholder="Enter State"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            placeholder="Enter City"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Zipcode</label>
                          <input
                            type="text"
                            className="form-control"
                            name="zipcode"
                            value={formData.zipcode}
                            onChange={handleChange}
                            placeholder="Enter Zipcode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Bank Details
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bankName"
                          value={formData.bankName}
                          onChange={handleChange}
                          placeholder="Enter Bank Name"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bankCode"
                          value={formData.bankCode}
                          onChange={handleChange}
                          placeholder="Enter Bank Code"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Branch</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bankBranch"
                          value={formData.bankBranch}
                          onChange={handleChange}
                          placeholder="Enter Bank Branch"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Bank Branch Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="bankBranchCode"
                          value={formData.bankBranchCode}
                          onChange={handleChange}
                          placeholder="Enter Branch Code"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Account Holder Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="accountHolderName"
                          value={formData.accountHolderName}
                          onChange={handleChange}
                          placeholder="Enter Account Holder"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Account Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="accountNumber"
                          value={formData.accountNumber}
                          onChange={handleChange}
                          placeholder="Enter Account Number"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pass-info">
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <Info />
                        </span>
                        Password
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6">
                        <div className="input-blocks mb-md-0 mb-sm-3">
                          <label>Password</label>
                          <div className="pass-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder="Enter Password"
                              value={formData.password}
                              onChange={handlePasswordChange}
                            />
                            <span
                              className={`fas toggle-password ${showPassword ? "fa-eye" : "fa-eye-slash"
                                }`}
                              onClick={handleTogglePassword}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6">
                        <div className="input-blocks mb-0">
                          <label>Confirm Password</label>
                          <div className="pass-group">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="pass-input"
                              placeholder="Enter Confirm Password"
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                            />
                            <span
                              className={`fas toggle-password ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                                }`}
                              onClick={handleToggleConfirmPassword}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />

                  </div>
                </div>
              </div>
            </div>
            {/* /product list */}
            <div className="text-end mb-3">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>
              <button to="#" className="btn btn-submit">
                Save Product
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
